export enum MfaDialogState {
  NONE,
  TWO_FACTOR_SETUP,
  AUTHENTICATOR_APP_SETUP,
  MANAGE_TWO_FACTOR_AUTHENTICATION,
  EMAIL_VERIFICATION,
}
